import React, { useEffect, useState } from "react";
import type { PollCampaignProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList, Image } from "react-native";
import { Checkbox, Icons, SearchBox } from "../../Components";
import moment from "moment-mini";
import { PartnerPortalApi } from "../api";

type FlashSelectorProps = {
    company_id:string,
    active_competitions:string[],
    onSelectCompetition:(campaign:PollCampaignProps) => void,
    onDeselectCompetition:(campaign:PollCampaignProps) => void
}
const FlashSelector = ({ company_id, active_competitions, onSelectCompetition, onDeselectCompetition }:FlashSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);
    const [ competitions, setCompetitions ] = useState<PollCampaignProps[]>([])
    const [ search, setSearch ] = useState('');

    const filtered_competitions = competitions.filter(pr => pr.name.toLowerCase().includes(search.toLowerCase())).slice(0,10)

    useEffect(() => {
        getCompetitions()
    },[company_id]);
    
    const getCompetitions = async() => {
        PartnerPortalApi.setEnvironment();
        const s_resp = await PartnerPortalApi.EngagementApi.getActiveFlashCampaigns(company_id);
        setCompetitions(s_resp);
    }

    const renderCompetitions = (data:{ item:PollCampaignProps, index:number }) => {
        const selected = active_competitions.includes(data.item.poll_campaign_id.toString());

        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => {
                    if(selected){ return onDeselectCompetition(data.item) }
                    return onSelectCompetition(data.item);
                }}
            >
                <Image
                    source={{ uri: data.item.campaign_image?.url }}
                    style={{ height: 35, width:35 }}
                    resizeMode="cover"
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Flash Markets</Text>
                </View>
                <Checkbox
                    checked={selected}
                    disabled
                    onSelect={() => console.log('')}
                />
            </Button>
        )
    }

    return (
        <View float style={{ padding:15 }}>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => setVisible(!visible)}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_competitions.length} Competitions</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <SearchBox
                onChange={(text) => setSearch(text)}
                hide_search_button
            />
            <FlatList
                data={filtered_competitions.sort((a,b) => a.status.localeCompare(b.status) || moment(b.create_datetime).unix() - moment(a.create_datetime).unix())}
                key={'comp_selector'}
                keyExtractor={item => item.poll_campaign_id.toString()}
                renderItem={renderCompetitions}
            />
            </View>
            :<></>}
        </View>
    )
}

export default FlashSelector